export const CondicaoInscricaoEnum = {
    ANALISADO: {
        id: 24,
        label: 'Analisado, em conformidade com a Lei nº 12.651/2012',
    },
    ANALISADO_AGUARDANDO_REGULARIZACAO_AMBIENTAL: {
        id: 7,
        label: 'Analisado, aguardando regularização ambiental (Lei nº 12.651/2012)',
    },
    CANCELADO_POR_DECISAO_JUDICIAL: {
        id: 16,
        label: 'Cancelado por decisão judicial',
    },
    CANCELADO_POR_DECISAO_ADMINISTRATIVA: {
        id: 17,
        label: 'Cancelado por decisão administrativa',
    },
    ANALISADO_PASSIVEL_EMISSAO_COTA: {
        id: 25,
        label: 'Analisado, em conformidade com a Lei nº 12.651/2012, com ativos ambientais',
    },
    ANALISADO_EM_REGULARIZACAO_AMBIENTAL: {
        id: 29,
        label: 'Analisado, em regularização ambiental (Lei nº 12.651/2012)',
    }

};

export const CondicaoEnum = {
    AGUARDANDO_VINCULO_TECNICO: {
        id: 'AGUARDANDO_VINCULO_TECNICO',
        nome: 'Aguardando vinculação do técnico',
        label: 'Aguard. vinculação',
        color: 'rgb(255 211 80)',
    },
    AGUARDANDO_ANALISE: {
        id: 'AGUARDANDO_ANALISE',
        nome: 'Aguardando análise',
        label: 'Aguard. análise',
        color: 'rgb(197 155 106)',
    },
    AGUARDANDO_REANALISE: {
        id: 'AGUARDANDO_REANALISE',
        nome: 'Aguardando reanálise',
        label: 'Aguard. reanálise',
        color: 'rgb(197 155 106)',
    },
    EM_ANALISE: {
        id: 'EM_ANALISE',
        nome: 'Em análise',
        label: 'Em análise',
        color: 'rgb(0 116 161)',
    },
    EM_REANALISE: {
        id: 'EM_REANALISE',
        nome: 'Aguardando nova análise',
        label: 'Em reanálise',
        color: 'rgb(0,137,211)',
    },
    AGUARDANDO_VALIDACAO_ANALISE: {
        id: 'AGUARDANDO_VALIDACAO_ANALISE',
        nome: 'Aguardando validação da análise',
        label: 'Aguard. validação',
        color: 'rgb(197 155 106)',
    },
    AGUARDANDO_ATENDIMENTO_PENDENCIA: {
        id: 'AGUARDANDO_ATENDIMENTO_PENDENCIA',
        nome: 'Aguardando atendimento, com pendência',
        label: 'Aguard. atendimento',
        color: 'var(--secondary-regular-red)',
    },
    PENDENCIA_ATENDIDA: {
        id: 'PENDENCIA_ATENDIDA',
        nome: 'Pendência atendida',
        label: 'Pendência atendida',
        color: 'rgb(28,23,99)',
    },
    AGUARDANDO_ASSINATURA: {
        id: 'AGUARDANDO_ASSINATURA',
        nome: 'Aguardando assinatura',
        label: 'Aguard. assinatura',
        color: 'rgb(230 113 33)',
    },
    TERMO_COMPROMISSO_ASSINADO: {
        id: 'TERMO_COMPROMISSO_ASSINADO',
        nome: 'Termo de compromisso assinado por todos',
        label: 'TC assinado',
        color: 'rgb(65 183 57)',
    },
    FINALIZADO_SEM_TERMO_COMPROMISSO: {
        id: 'FINALIZADO_SEM_TERMO_COMPROMISSO',
        nome: 'Processo finalizado sem Termo de Compromisso',
        label: 'Finalizado sem TC',
        color: 'rgb(156 39 176)',
    },
    PRAZO_ASSINATURA_EXPIRADO: {
        id: 'PRAZO_ASSINATURA_EXPIRADO',
        nome: 'Prazo da assinatura expirado.',
        label: 'Prazo assinatura expirado',
        color: 'rgb(121, 85, 72)',
    },
    ANALISE_CANCELADA: {
        id: 'ANALISE_CANCELADA',
        nome: 'Análise cancelada devido ao cancelamento do imóvel.',
        label: 'Análise cancelada',
        color: 'rgb(245, 108, 108)',
    },
};

export const AcaoEnum = {
    VISUALIZAR_FICHA_IMOVEL: {
        id: 'VISUALIZAR_FICHA_IMOVEL',
        nome: 'Detalhes do imóvel',
        icon: 'mdi-magnify',
    },
    VISUALIZAR_ANALISE: {
        id: 'VISUALIZAR_ANALISE',
        nome: 'Ver Análise',
        icon: 'mdi-eye',
    },
    ANALISAR: {
        id: 'ANALISAR',
        nome: 'Iniciar/Continuar Análise',
        icon: 'mdi-pencil-box-outline',
    },
    VALIDAR: {
        id: 'VALIDAR',
        nome: 'Iniciar/Continuar Validação',
        icon: 'mdi-pencil-box-outline',
    },
    VISUALIZAR_DOCUMENTOS: {
        id: 'VISUALIZAR_DOCUMENTOS',
        nome: 'Documentos da análise',
        icon: 'mdi-chart-box-multiple-outline',
    },
    VINCULAR_TECNICO: {
        id: 'VINCULAR_TECNICO',
        nome: 'Vincular técnico para análise',
        icon: 'mdi-link-variant',
    },
    DESVINCULAR_TECNICO: {
        id: 'DESVINCULAR_TECNICO',
        nome: 'Desvincular técnico para análise',
        icon: 'mdi-link-variant',
    },
    VISUALIZAR_TERMO_COMPROMISSO: {
        id: 'VISUALIZAR_TERMO_COMPROMISSO',
        nome: 'Visualizar Termo de compromisso',
        icon: 'mdi-text-box-search-outline',
    },
    DOWNLOAD_TERMO_COMPROMISSO: {
        id: 'DOWNLOAD_TERMO_COMPROMISSO',
        nome: 'Baixar Termo de compromisso',
        icon: 'mdi-text-box-search-outline',
    },
    VISUALIZAR_ANALISE_HISTORICO: {
        id: 'VISUALIZAR_ANALISE_HISTORICO',
        nome: 'Visualizar Histórico da Análise',
        icon: 'mdi-eye',
    },
    BAIXAR_DEMONSTRATIVO_IMOVEL: {
        id: 'BAIXAR_DEMONSTRATIVO_IMOVEL',
        nome: 'Download Demonstrativo do Imóvel',
        icon: 'mdi-download',
    },
    EXPORTAR_AREAS_RECOMPOR: {
        id: 'EXPORTAR_AREAS_RECOMPOR',
        nome: 'Áreas a recompor',
        icon: 'mdi-tree',
    },
    CANCELAR_IMOVEL: {
        id: 'CANCELAR_IMOVEL',
        nome: 'Cancelar Imóvel',
        icon: 'mdi-cancel',
    },
    SUSPENDER_IMOVEL: {
        id: 'SUSPENDER_IMOVEL',
        nome: 'Suspender Imóvel',
        icon: 'mdi-minus-circle-outline',
    },
    REVERTER_SUSPENSAO_IMOVEL: {
        id: 'REVERTER_SUSPENSAO_IMOVEL',
        nome: 'Reverter suspensão',
        icon: 'mdi-restore',
    },
    SOLICITAR_NOVA_ANALISE: {
        id: 'SOLICITAR_NOVA_ANALISE',
        nome: 'Solicitar nova análise',
        icon: 'mdi-autorenew',
    },
    ANALISAR_SOLICITACAO_ENVIO_MONITORAMENTO: {
        id: 'ANALISAR_SOLICITACAO_ENVIO_MONITORAMENTO',
        nome: 'Analisar solicitação',
        icon: 'mdi-magnify',
    },
    VISUALIZAR_ANALISE_SOLICITACAO_ENVIO_MONITORAMENTO: {
        id: 'VISUALIZAR_ANALISE_SOLICITACAO_ENVIO_MONITORAMENTO',
        nome: 'Visualizar análise',
        icon: 'mdi-magnify',
    }
};

export const EtapaEnum = {
    IARA: {
        id: 'IARA',
        nome: 'Etapa IARA',
    },
    MRA: {
        id: 'MRA',
        nome: 'Etapa MRA',
    },
    PRADA: {
        id: 'PRADA',
        nome: 'Etapa PRADA',
    },
    RESUMO: {
        id: 'RESUMO',
        nome: 'Etapa RESUMO',
    },
};

export const CondicaoValidacaoEnum = {
    AGUARDANDO_ANALISE: {
        id: 'AGUARDANDO_ANALISE',
        nome: 'Aguardando análise',
        style: {
            chip: {
                backgroundColor: '#dcdfc3ff',
                color: '#e4d129ff',
                icon: 'mdi-check',
            },
        },
    },
    APROVADO: {
        id: 'APROVADO',
        nome: 'Aprovado',
        style: {
            chip: {
                backgroundColor: '#c3dfc4',
                color: '#359138',
                icon: 'mdi-check',
            },
        },
    },
    REPROVADO: {
        id: 'REPROVADO',
        nome: 'Reprovado',
        style: {
            chip: {
                backgroundColor: '#efb7af',
                color: '#b01d09',
                icon: 'mdi-close',
            },
        },
    },
};

export const ListaCondicoes = {
    PAGINA_INICIAL_GO: [
        {id: 'AGUARDANDO_VINCULO_TECNICO', nome: 'Aguardando vinculação do técnico'},
        {id: 'AGUARDANDO_ANALISE', nome: 'Aguardando análise'},
        {id: 'AGUARDANDO_REANALISE', nome: 'Aguardando reanálise'},
        {id: 'EM_ANALISE', nome: 'Em análise'},
        {id: 'AGUARDANDO_VALIDACAO_ANALISE', nome: 'Aguardando validação da análise'},
        {id: 'AGUARDANDO_ASSINATURA', nome: 'Aguardando assinatura'},
        {id: 'AGUARDANDO_ATENDIMENTO_PENDENCIA', nome: 'Aguardando atendimento, com pendência'},
        {id: 'EM_REANALISE', nome: 'Em Reanálise'},
        {id: 'TERMO_COMPROMISSO_ASSINADO', nome: 'Termo de compromisso assinado'},
        {id: 'PRAZO_ASSINATURA_EXPIRADO', nome: 'Prazo de assinatura expirado' },
    ],
    VALIDACAO_PROPOSTA: [
        {id: 'AGUARDANDO_VALIDACAO_ANALISE', nome: 'Aguardando validação da análise'},
    ],
    CAIXA_ENTRADA_GO: [
        {id: 'AGUARDANDO_VINCULO_TECNICO', nome: 'Aguardando vinculação do técnico'}
    ],
    TERMO_COMPROMISSO: [
        {id: 'AGUARDANDO_ASSINATURA', nome: 'Aguardando assinatura'},
        {id: 'TERMO_COMPROMISSO_ASSINADO', nome: 'Termo de compromisso assinado'},
        {id: 'PRAZO_ASSINATURA_EXPIRADO', nome: 'Prazo de assinatura expirado' },
    ],
    ANALISE_PROPOSTA: [
        {id: 'AGUARDANDO_ANALISE', nome: 'Aguardando análise'},
        {id: 'AGUARDANDO_REANALISE', nome: 'Aguardando reanálise'},
        {id: 'EM_ANALISE', nome: 'Em análise'},
        {id: 'EM_REANALISE', nome: 'Em reanálise'},
    ],
    CONSULTAR_PROCESSOS_GO: [
        { id: 'AGUARDANDO_ANALISE', nome: 'Aguardando análise' },
        { id: 'AGUARDANDO_ASSINATURA', nome: 'Aguardando assinatura' },
        { id: 'AGUARDANDO_ATENDIMENTO_PENDENCIA', nome: 'Aguardando atendimento, com pendência' },
        { id: 'AGUARDANDO_REANALISE', nome: 'Aguardando reanálise' },
        { id: 'AGUARDANDO_VALIDACAO_ANALISE', nome: 'Aguardando validação da análise' },
        { id: 'AGUARDANDO_VINCULO_TECNICO', nome: 'Aguardando vinculação do técnico' },
        { id: 'ANALISE_CANCELADA', nome: 'Análise cancelada' },
        { id: 'EM_ANALISE', nome: 'Em análise' },
        { id: 'EM_REANALISE', nome: 'Em Reanálise' },
        { id: 'FINALIZADO_SEM_TERMO_COMPROMISSO', nome: 'Finalizado sem Termo de Compromisso' },
        { id: 'PRAZO_ASSINATURA_EXPIRADO', nome: 'Prazo de assinatura expirado' },
        { id: 'PENDENCIA_ATENDIDA', nome: 'Pendência atendida' },
        { id: 'TERMO_COMPROMISSO_ASSINADO', nome: 'Termo de compromisso assinado' },
    ],
    CONSULTAR_PROCESSOS: [
        { id: 'AGUARDANDO_ANALISE', nome: 'Aguardando análise' },
        { id: 'AGUARDANDO_ASSINATURA', nome: 'Aguardando assinatura' },
        { id: 'AGUARDANDO_ATENDIMENTO_PENDENCIA', nome: 'Aguardando atendimento, com pendência' },
        { id: 'AGUARDANDO_REANALISE', nome: 'Aguardando reanálise' },
        { id: 'AGUARDANDO_VALIDACAO_ANALISE', nome: 'Aguardando validação da análise' },
        { id: 'ANALISE_CANCELADA', nome: 'Análise cancelada' },
        { id: 'EM_ANALISE', nome: 'Em análise' },
        { id: 'EM_REANALISE', nome: 'Em reanálise' },
        { id: 'FINALIZADO_SEM_TERMO_COMPROMISSO', nome: 'Finalizado sem Termo de Compromisso' },
        { id: 'PRAZO_ASSINATURA_EXPIRADO', nome: 'Prazo de assinatura expirado' },
        { id: 'PENDENCIA_ATENDIDA', nome: 'Pendência atendida' },
        { id: 'TERMO_COMPROMISSO_ASSINADO', nome: 'Termo de compromisso assinado' },
    ],
    CONSULTAR_PROCESSOS_SEMIL: [
        {id: 'TERMO_COMPROMISSO_ASSINADO', nome: 'Termo de compromisso assinado'},
    ],
    REANALISE_PROPOSTA: [
        {id: 'EM_REANALISE', nome: 'Em Reanálise'}
    ],
};

export const TipoAssinaturaEnum = {
    GERENTE_OPERACIONAL: { id: 1, nome: 'Técnico(a) responsável pela CATI/SAA' },
    PROPRIETARIO_POSSUIDOR: { id: 2, nome: 'Compromissário' },
    COMPROMISSARIO: { id: 3, nome: 'Compromissário Terceiro' },
};
